export default {
  UPDATE: 'ott/landings/config/update',
};
